<div class="cpp-content-resources">
  <div class="cpp-heading">
    <div class="cpp-heading__content">
      <span class="cpp-heading__title">{{ labels["resources4u.title"] }}</span>
    </div>
  </div>

  <p>{{ labels["resources4u.description"] }}</p>

  <div class="spotlight">
    <a
      class="cpp-button cpp-button--lg cpp-button--action"
      target="Resources4u"
      [href]="redirectUrl"
    >
    <button class="cpp-button-access-platform"><b>{{ labels['resources4u.button'] }}</b></button>
    </a>
    </div>
    <div class="banner-image"></div>
</div>
